import { render, staticRenderFns } from "./GeneralReceiptFormLine.vue?vue&type=template&id=3563d543"
import script from "./GeneralReceiptFormLine.vue?vue&type=script&lang=js"
export * from "./GeneralReceiptFormLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports